<template>
  <em ref="iconContainerRef" class="svg-icon" v-html="svgStr"></em>
</template>

<script>
const DEFAULT_ICON =
  '<?xml version="1.0" encoding="UTF-8"?><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40 23V14L31 4H10C8.89543 4 8 4.89543 8 6V42C8 43.1046 8.89543 44 10 44H22" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M34 27L36.5234 32.5269L42.5595 33.2188L38.0829 37.3266L39.2901 43.2812L34 40.293L28.7099 43.2812L29.9171 37.3266L25.4405 33.2188L31.4766 32.5269L34 27Z" fill="none" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M30 4V14H40" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

export default {
  name: 'SvgRender',
  props: {
    iconSvg: {
      type: String,
      default: ''
    }
  },
  computed: {
    svgStr() {
      return this.iconSvg || DEFAULT_ICON;
    }
  },
  mounted() {
    this.$nextTick(() => {
      try {
        this.$refs.iconContainerRef.querySelectorAll('svg').forEach(svg => {
          svg.hasAttribute('fill') &&
            svg.getAttribute('fill') !== 'none' &&
            svg.setAttribute('fill', 'currentColor');

          svg.querySelectorAll('path').forEach(path => {
            path.hasAttribute('fill') &&
              path.getAttribute('fill') !== 'none' &&
              path.setAttribute('fill', 'currentColor');

            path.hasAttribute('stroke') &&
              path.getAttribute('stroke') !== 'none' &&
              path.setAttribute('stroke', 'currentColor');
          });
        });
      } catch (error) {
        console.log(error);
      }
    });
    // 修改svg的颜色
  }
};
</script>

<style lang="scss" scoped>
.svg-icon {
  display: inline-block;
  width: 42px;
  height: 42px;

  ::v-deep svg {
    width: 100%;
    height: 100%;
    color: var(--main-color);
  }
}
</style>
